import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';
import Typography from '../../../Typography/index.js';
import { getTypographyStyles } from '../../../Typography/Typography.styles.js';

var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var SliderHeaderWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n"])));
var SliderValueWrapper = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  font-variant-numeric: tabular-nums;\n  gap: ", ";\n  margin-left: auto;\n  text-align: right;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.sizing.tiny;
});
var SliderHeaderText = styled(Typography).attrs(function (_ref2) {
  var $isSliderActive = _ref2.$isSliderActive;
  return {
    'aria-disabled': !$isSliderActive
  };
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (_ref3) {
  var theme = _ref3.theme,
    $isSliderActive = _ref3.$isSliderActive;
  return $isSliderActive ? theme.colours.ink.primary.main : theme.applyOpacity(theme.colours.ink.primary.main, 'overlay');
});
var SliderTitle = styled(getTypographyStyles('headingMedium'))(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  color: ", ";\n  display: flex;\n  font-variant-numeric: tabular-nums;\n  gap: ", ";\n"])), function (_ref4) {
  var theme = _ref4.theme;
  return theme.colours.ink.primary.main;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.sizing.small;
});

export { SliderHeaderText, SliderHeaderWrapper, SliderTitle, SliderValueWrapper };
//# sourceMappingURL=SliderHeader.styles.js.map
